import React, { Component } from 'react'
import { CommonValidationMessages } from '../../../utils/Messages';
import { getAuthProps } from '../../../utils/AuthenticationLibrary';
import { isValidForm } from '../../../utils/validation/CommonValidator';
import ButtonGrp from '../../../components/UIComponent/Buttons/ButtonGrp';
import { AgGridReact } from "ag-grid-react";
import "ag-grid-enterprise";
import SwalServices from '../../../services/swalServices/SwalServices';
import { MrsRegisterPopup } from './SalesReturnToStoreTable';
import AccountTransactionServices from '../../../services/axiosServices/apiServices/AccountTransactionServices';
import AccountMasterServices from '../../../services/axiosServices/apiServices/AccountMasterServices';
import TransactionStockServices from '../../../services/axiosServices/apiServices/TransactionStockServices';
import moment from 'moment';
import { decryptAES } from '../../../utils/Encryption';
import { permission } from '../../../utils/enums/ValidationMessage';

export default class SalesReturnToStore extends Component {

    constructor(props) {
        super(props)
        this.accountTransactionServices = new AccountTransactionServices();
        this.accountMasterServices = new AccountMasterServices();
        this.SwalServices = new SwalServices();
        this.transactionStockServices = new TransactionStockServices();
        this.state = {
            permissions: {
                isAddEdit: false,
                isDelete: false,
                isView: false,
            },
            globalUserID: '',
            usp_Users: [],
            isModalOpen: false,
            isSaving: false,
            open: false,
            isTable2Expanded: false,
            isShown: false,
            rowData: [],
            selectedRowsForfirstPOListOfVendors: [],
            partyAccountList: [],
            colDefs: [],
            firstSalesReturnList: [],
            secondSalesReturnList: [],
            itemRowData: [],
            itemColDefs: [],
            paginationPageSize: 50,
            rowHeight: 40,
            idCompany: 0,
            idUser: 0,
            registerObject: {
                salesReturnInNo: '',
                salesInDate: '',
                idEmployee: 0,
                EmployeeList: [],
                idPriority: 0,
                PriorityList: [],
                idVendor: 0,
                idSalesReturnInward: 0,
                updateStatus: 0,
                vendorList: [],
                idInv: 0,
                invTyleList: [],
                address: '',
            },
            itemObject: {
                drawingNo: '',
                type: '',
                itemName: '',
                quantity: '',
                remarks: '',
                keyId: null,
                idItem: 0,
                idSalesReturn: 0,
                idSalesReturnItems: 0,
                pendingQty: 0,
                basePendingQty: 0
            },
            validState: {
                isValid: true,
                error: {},
            },
            validationRulesForRegister: {
                idVendor: [
                    {
                        type: "require",
                        message: CommonValidationMessages.SelectRequired.replace(
                            "{0}",
                            "vendor"
                        ),
                    },
                ],
            },
        }
    }

    componentDidMount = () => {
        let params = new URLSearchParams(window.location.search);
        let id = params.get("id")
        if (id) {
            let urlId = decryptAES(id)
            if (urlId) {
                if (urlId != null) {
                    this.setState({ urlId: urlId });
                }
            }
        }

        let prop = getAuthProps()
        if (prop.idCompany && prop.idCompany > 0) {
            this.setState({ idCompany: prop.idCompany, idUser: prop.idUser ? prop.idUser : 0, entryBy: prop.name, companyName: prop.companyName, globalUserID: prop.globalUserID }, () => {
                this.procSelectAllRecordsSP();
                this.usp_Master_PartyAccountSelect()
                this.USP_GetAllUsers();
            });
        }
    }

    USP_GetAllUsers = () => {
        this.accountTransactionServices.usp_GetAllUsers().then((response) => {
            if (response.statusCode === 200 && response.responseItem !== null) {
                let data = response.responseItem.responseContent;
                if (data.length > 0) {
                    this.setState({
                        usp_Users: data,
                    });
                }
            }
        });
    }

    procSelectAllRecordsSP = () => {
        let request = {
            formname: "Sales Return Inward",
            idCompany: this.state.idCompany,
            allowToRateVisible: 1,
            idUser: 0,
        };
        this.accountTransactionServices.procSelectAllRecordsSP(request).then((response) => {
            if (response.statusCode == 200 && response.responseItem !== null) {
                let permissions = response.responseItem.responseContent[0][0];
                if (permissions.view) {
                    this.setPermissions(permissions);
                    let data = response.responseItem.responseContent[1];
                    if (data.length > 0) {
                        const dynamicColDefs = Object.keys(data[0]).map((key) => ({
                            field: key.includes(".") ? key.replace(/\./g, "_") : key,
                            headerName: key.replace(/([A-Z])/g, ' $1').charAt(0).toUpperCase() + key.replace(/([A-Z])/g, ' $1').slice(1),
                            minWidth: this.getColumnWidth(key) !== undefined ? this.getColumnWidth(key) : window.innerWidth * 0.06,
                            width: this.getPinnedColumnWidth(key) !== undefined ? this.getPinnedColumnWidth(key) : window.innerWidth * 0.05,
                            flex: 1,
                            filter: true,
                            floatingFilter: true,
                            hide: ["idSalesReturnInward"].includes(key) ? true : false,
                            valueGetter: (params) => params.data[key],
                            valueFormatter: key.toLowerCase().includes("date") ? (params) => {
                                if (!params.value) return "";
                                const date = new Date(params.value);
                                return moment(date).format('DD-MM-YYYY')
                            } : undefined,
                        }));
                        var colName = dynamicColDefs[0].field;
                        let id = data ? data[0][colName] : 0;
                        this.setState({
                            rowData: data,
                            colDefs: dynamicColDefs,
                            caption: "Sales Return Inward",
                            colName: colName
                        }, () => {
                            this.procSelectAllRecord2GridviewSP(id, "Sales Return Inward");
                            if (this.state.urlId) {
                                this.openPopUpFromURLId(this.state.urlId)
                            }
                        });
                    } else {
                        if (this.gridApi) {
                            this.gridApi.hideOverlay();
                            this.gridApi.showNoRowsOverlay();
                        }
                    }
                } else {
                    window.location.href = "/authentication/UnAuthorized";
                }
            }
        });
    }

    setPermissions = (permissions) => {
        let data = this.state.permissions;
        data.isAddEdit = permissions.addEdit;
        data.isDelete = permissions.delete;
        data.isView = permissions.view;
        this.setState({ permissions: data });
    }

    getColumnWidth = (key) => {
        const colwidth = {
            "invoiceDate": window.innerWidth * 0.08,
            "vendor": window.innerWidth * 0.2,
            "gatePassNo": window.innerWidth * 0.06,
            "totalQty": window.innerWidth * 0.06,
            "totalAmt": window.innerWidth * 0.06,
            "extraCharges": window.innerWidth * 0.06,
            "discount": window.innerWidth * 0.06,
            "taxAmt": window.innerWidth * 0.06,
            "finalAmt": window.innerWidth * 0.06,
            "approvalStatus": window.innerWidth * 0.08,
        }
        return colwidth[key]
    }
    getPinnedColumnWidth = (key) => {
        const colwidth = {
            "sR.No": window.innerWidth * 0.05,
            "jobWorkNo": window.innerWidth * 0.09,
            "jobWorkInwardDate": window.innerWidth * 0.08,
            "jobWorkFrom": window.innerWidth * 0.08,
            "invoiceNo": window.innerWidth * 0.06,
        }
        return colwidth[key]
    }

    procSelectAllRecord2GridviewSP = (id, formname) => {
        let request = {
            id: id,
            formname: formname,
            allowToRateVisible: 1,
        }
        if (id > 0) {
            this.accountTransactionServices.procSelectAllRecord2GridviewSP(request).then((response) => {
                if (response.statusCode == 200 && response.responseItem !== null) {
                    const dynamicData = response.responseItem.responseContent;
                    if (dynamicData.length > 0) {
                        const dynamicColDefs = Object.keys(dynamicData[0]).map((key) => ({
                            field: key,
                            headerName: key.replace(/([A-Z])/g, ' $1').charAt(0).toUpperCase() + key.replace(/([A-Z])/g, ' $1').slice(1),
                            minWidth: this.getColumnWidth2(key) !== undefined ? this.getColumnWidth2(key) : window.innerWidth * 0.06,
                            filter: true,
                            floatingFilter: true,
                            flex: 1,
                        }));
                        this.setState({
                            table2Data: dynamicData,
                            table2ColDefs: dynamicColDefs,
                            isTable2Expanded: true
                        });
                    }
                }
            });
        }
    }
    getColumnWidth2 = (key) => {
        const colwidth = {
            "drawingNo": window.innerWidth * 0.11,
            "itemCategory": window.innerWidth * 0.16,
            "itemName": window.innerWidth * 0.2,
            "hsnCode": window.innerWidth * 0.06,
            "quantity": window.innerWidth * 0.06,
            "rate": window.innerWidth * 0.06,
            "taxableAmt": window.innerWidth * 0.06,
            "sgst": window.innerWidth * 0.04,
            "sgstAmt": window.innerWidth * 0.06,
            "cgst": window.innerWidth * 0.04,
            "cgstAmt": window.innerWidth * 0.06,
            "igst": window.innerWidth * 0.04,
            "igstAmt": window.innerWidth * 0.06,
            "netTotal": window.innerWidth * 0.08,
        }
        return colwidth[key]
    }

    // usp_Master_PartyAccountSelect = () => {
    //     this.accountTransactionServices.usp_Master_PartyAccountSelect(this.state.idCompany).then((response) => {
    //         if (response.statusCode == 200 && response.responseItem !== null) {
    //             let dynamicData = response.responseItem.responseContent;
    //             if (dynamicData.length > 0) {
    //                 dynamicData = dynamicData.map((x) => ({
    //                     value: x.idPartyAccount,
    //                     label: x.partyACName,
    //                     partyAddress: x.p_Address
    //                 }));

    //                 this.setState({ partyAccountList: dynamicData }, () => {
    //                 }, () => {
    //                     if (this.gridApi) {
    //                         this.gridApi.hideOverlay();
    //                     }
    //                 });
    //             }
    //         }
    //     });
    // }

    usp_Master_PartyAccountSelect = () => {
        this.transactionStockServices.usp_Master_PartyAccountSelectCustomerForSalesReturnInward([this.state.idCompany, this.state.registerObject.updateStatus, this.state.registerObject.idVendor]).then((response) => {
            if (response.statusCode == 200 && response.responseItem !== null) {
                let dynamicData = response.responseItem.responseContent;
                if (dynamicData.length > 0) {
                    dynamicData = dynamicData.map((x) => ({
                        value: x.idPartyAccount,
                        label: x.partyACName,
                        partyAddress: x.p_Address
                    }));

                    this.setState({ partyAccountList: dynamicData }, () => {
                    }, () => {
                        if (this.gridApi) {
                            this.gridApi.hideOverlay();
                        }
                    });
                }
            }
        });
    }

    onGridReady = (params) => {
        this.gridApi = params.api;
        this.gridColumnApi = params.columnApi;
        this.gridApi.showLoadingOverlay();
    };

    openPopUpForAddingItem = () => {
        if (!this.state.permissions.isAddEdit) {
            this.SwalServices.Error(permission.add);
            return;
        }
        this.setState({ open: false })
        this.transactionStockServices.getCountForSalesReturnInward(this.state.idCompany).then((response) => {
            if (response.statusCode == 200 && response.responseItem !== null) {
                let nextNum = response.responseItem.responseContent[0].totalCount + 1

                let formatted = '';
                if (nextNum.toString().length === 1) {
                    formatted = '00' + nextNum;
                } else if (nextNum.toString().length === 2) {
                    formatted = '0' + nextNum;
                } else {
                    formatted = nextNum.toString();
                }
                let materialObject = this.state.registerObject
                materialObject.salesReturnInNo = formatted
                materialObject.salesInDate = moment(new Date()).format('YYYY-MM-DD')
                this.setState({ materialObject: materialObject }, () => {
                    this.setState({ isModalOpen: true }, () => {
                        this.resetDetailsFields();
                    })
                })
            }
        });
    };

    onRowDoubleClicked = (event) => {
        if (!this.state.permissions.isAddEdit) {
            this.SwalServices.Error(permission.edit);
            return;
        }
        this.getTransactionSalesReturnInwardSelectbyId(event.data.idSalesReturnInward);
        let validState = this.state.validState;
        validState.isValid = true;
        validState.error = {};
        this.setState({
            validState: validState
        });
    };

    toggleExpandCollapseTable = (tableNumber) => {
        this.setState((prevState) => {
            if (tableNumber === 2) {
                return { isTable2Expanded: !prevState.isTable2Expanded };
            } else if (tableNumber === 3) {
                return { isTable3Expanded: !prevState.isTable3Expanded };
            } else {
                return {};
            }
        });
    };

    setOpenModel = () => {
        this.setState({ isModalOpen: !this.state.isModalOpen });
    };
    closePopup = () => {
        this.setState({ isModalOpen: false, });
    };

    handleChangeForRegister = (event, name) => {
        let value = event.target.value.toUpperCase();
        let details = this.state.registerObject;
        details[name] = value;
        this.setState({ registerObject: details });
    }
    handleChangeForItem = (event, name) => {
        let value = event.target.value.toUpperCase();
        let details = this.state.itemObject;
        details[name] = value;
        this.setState({ itemObject: details });
    }

    handleChangeForDropdown = (event, name, field) => {
        let details = this.state.registerObject;
        let details1 = this.state.itemObject
        let value = event.value;
        if (field === 'registerObject') {
            details[name] = value;
            if (name === 'idVendor') {
                details.address = this.state.partyAccountList.find((x) => x.value === value).partyAddress
            }
            this.setState({ registerObject: details });
        } else {
            details1[name] = value;
            this.setState({ itemObject: details });
        }
    }

    resetDetailsFields = () => {
        let details = this.state.registerObject
        details.idEmployee = 0
        details.idVendor = 0
        details.address = ''
        details.idSalesReturnInward = 0
        details.updateStatus = 0
        this.setState({ registerObject: details, itemRowData: [] })

        let validState = this.state.validState;
        validState.isValid = true;
        validState.error = {};
        this.setState({
            validState: validState
        }, () => {
            this.usp_Master_PartyAccountSelect()
        });
    }

    back = () => {
        this.setState({ open: false })
    }

    addSalesReturn = () => {
        if (this.state.registerObject.idVendor > 0) {
            this.setState({ open: true }, () => {
                this.getTransaction_SalesReturnSelectbyIDVendor();
            })
        } else {
            this.SwalServices.Alert("Please Select Vendor First");
        }
    }

    getTransaction_SalesReturnSelectbyIDVendor = () => {
        let request = [this.state.registerObject.idVendor, this.state.idCompany, this.state.registerObject.updateStatus, this.state.registerObject.idSalesReturnInward];
        this.transactionStockServices.getTransaction_SalesReturnSelectbyIDVendor(request).then((response) => {
            if (response.statusCode == 200 && response.responseItem !== null) {
                let res = response.responseItem.responseContent;
                let data = this.state.firstSalesReturnList;
                let idSalesReturn = 0;
                data = [];
                if (res.length > 0) {
                    res.map((x) => {
                        x.Select = false;
                        x.returnDate = x.returnDate ? moment(x.returnDate).format("DD-MM-YYYY") : '';
                    });
                    data = res;
                    idSalesReturn = res[0]?.idSalesReturn;
                }
                this.setState({ firstSalesReturnList: data }, () => {
                    if (idSalesReturn > 0) {
                        this.USP_Transaction_SalesReturnSelectbyID_PendingQty(idSalesReturn);
                    }
                });
            }
        });
    }

    USP_Transaction_SalesReturnSelectbyID_PendingQty = (idSalesReturn) => {
        if (idSalesReturn > 0) {
            let request = [idSalesReturn, this.state.registerObject.updateStatus, this.state.registerObject.idSalesReturnInward];
            this.transactionStockServices.USP_Transaction_SalesReturnSelectbyID_PendingQty(request).then((response) => {
                if (response.statusCode == 200 && response.responseItem !== null) {
                    let res = response.responseItem.responseContent;
                    this.setState({ secondSalesReturnList: res });
                }
            });
        }
    }

    USP_Transaction_SalesReturnSelectbyID_PendingQtyForMultiSelect = async (idSalesReturn) => {
        if (idSalesReturn <= 0) return [];
        let request = [idSalesReturn, this.state.registerObject.updateStatus, this.state.registerObject.idSalesReturnInward];
        try {
            const response = await this.transactionStockServices.USP_Transaction_SalesReturnSelectbyID_PendingQty(request);
            if (response.statusCode === 200 && response.responseItem !== null) {
                return response.responseItem.responseContent;
            }
            return [];
        } catch (error) {
            return [];
        }
    };


    onSelectionChanged = (selectedRows) => {
        this.setState({ selectedRowsForfirstPOList: selectedRows }, async () => {
            const requests = selectedRows.map(element => {
                return this.USP_Transaction_SalesReturnSelectbyID_PendingQtyForMultiSelect(element.idSalesReturn);
            });

            const results = await Promise.all(requests);

            const mergedData = results.flat();
            this.setState({ secondSalesReturnList: mergedData });
        });
    }

    onSelectionItemsChanged = (selectedRows) => {
        this.setState({ selectedRowsForfirstPOListOfVendors: selectedRows })
    }

    addProduct = async () => {
        const selectedRows = this.state.selectedRowsForfirstPOListOfVendors;
        if (selectedRows.length > 0) {
            const grouped = selectedRows.reduce((acc, item) => {
                const key = `${item.idItem}_${item.itemDrawingNo}_${item.itemName}`;

                const returnQuantity = Number(item.returnQuantity || 0);
                const pendingQty = Number(item.pendingQty || 0);

                if (!acc[key]) {
                    acc[key] = {
                        ...item,
                        returnQuantity: returnQuantity,
                        originalPendingQty: pendingQty,
                    };
                } else {
                    acc[key] = {
                        ...acc[key],
                        returnQuantity: acc[key].returnQuantity + returnQuantity,
                        originalPendingQty: acc[key].returnQuantity + pendingQty,
                    };
                }
                return acc;
            }, {});

            const newItems = Object.values(grouped);

            const existingIds = new Set(
                this.state.itemRowData.map(item => item.idSalesReturnItems)
            );

            const itemsToAdd = newItems.filter(
                item => !existingIds.has(item.idSalesReturnItems)
            );

            this.setState((prevState) => ({
                itemRowData: [...prevState.itemRowData, ...itemsToAdd],
                open: false
            }));
        } else {
            this.SwalServices.Error('Please select item')
        }
    };

    onItemRowDataClicked = (event) => {
        let details = this.state.itemObject;
        details.drawingNo = event.data.itemDrawingNo;
        details.itemName = event.data.itemName;
        details.type = event.data.itemItemType;
        details.quantity = event.data.quantity;
        details.keyId = event.rowIndex
        details.idItem = event.data.idItem
        details.idSalesReturn = event.data.idSalesReturn
        details.idSalesReturnItems = event.data.idSalesReturnItems
        details.pendingQty = event.data.pendingQty
        details.remarks = event.data.remarks
        details.basePendingQty = event.data.originalPendingQty

        this.setState({ itemObject: details });
    };

    insertItem = (flag) => {
        if (flag === 'Update') {

            let details = this.state.itemObject;
            const index = details.keyId;
            let itemList = [...this.state.itemRowData];

            const remainingQty = details.basePendingQty - details.quantity;

            if (details.quantity <= 0) {
                return this.SwalServices.Alert("Quantity must be greater than 0");
            }

            if (remainingQty < 0) {
                return this.SwalServices.Alert("Entered quantity cannot be greater than Pending Quantity");
            }

            if (index !== null && index >= 0) {
                itemList[index] = {
                    ...itemList[index],
                    quantity: Number(details.quantity),
                    pendingQty: remainingQty,
                    remarks: details.remarks,
                };
            }

            this.setState({ itemRowData: itemList }, () => {
                this.clear();
            });
        }
    }

    clear = () => {
        let object = this.state.itemObject
        object.drawingNo = ''
        object.type = ''
        object.itemName = ''
        object.quantity = ''
        object.remarks = ''
        object.keyId = null
        object.idItem = 0
        object.idSalesReturn = 0
        object.idSalesReturnItems = 0
        object.pendingQty = 0
        this.setState({ itemObject: object })
    }

    delete = () => {
        let details = this.state.itemObject;
        const index = details.keyId;

        let itemList = [...this.state.itemRowData];

        if (index !== null && index >= 0) {
            itemList.splice(index, 1);
        }

        this.setState({ itemRowData: itemList }, () => {
            this.clear();
        });
    }

    isValidAllFieldsForWork = () => {
        const newValidState = isValidForm(
            this.state.registerObject,
            this.state.validationRulesForRegister,
            this.state.validState,
        );
        this.setState({ validState: newValidState });
        return newValidState.isValid;
    }

    submit = () => {
        if (this.isSubmitting) {
            return;
        }
        const isValidAllFields = this.isValidAllFieldsForWork();
        if (isValidAllFields) {
            if (this.state.itemRowData.length > 0) {
                const invalidItems = this.state.itemRowData.filter(
                    item => !item.quantity || Number(item.quantity) <= 0
                );

                if (invalidItems.length > 0) {
                    this.SwalServices.Alert("Quantity must be greater than 0 for all items.");
                    return;
                }

                let details = this.state.registerObject;
                let details2 = this.state.itemRowData;
                let salesReturnInwardList = [];
                details2.map((x) => {
                    let request = {
                        drawingNo: x.itemDrawingNo ? x.itemDrawingNo : '',
                        itemType: x.itemItemType ? x.itemItemType : 0,
                        idItem: x.idItem,
                        quantity: x.quantity,
                        pendingQty: x.pendingQty,
                        itemRemarks: x.remarks ? x.remarks : 0,
                        idSalesReturn: x.idSalesReturn ? x.idSalesReturn : 0,
                        idSalesReturnItems: x.idSalesReturnItems ? x.idSalesReturnItems : 0,
                    }
                    salesReturnInwardList.push(request);
                });
                if (details !== "") {
                    let requestData = {
                        idSalesReturnInward: details.idSalesReturnInward,
                        salesReturnInNo: details.salesReturnInNo,
                        idVendor: details.idVendor,
                        updateStatus: details.updateStatus,
                        date: (details.salesInDate && details.salesInDate !== 'Invalid date') ? details.salesInDate : null,
                        idEmployee: details.idEmployee,
                        idCompany: this.state.idCompany,
                        e_Date: details.e_Date ? details.e_Date : new Date(),
                        e_IDUser: this.state.idUser,
                        isUpdated: details.updateStatus > 0 ? true : false,
                        updatedDate: details.updateStatus > 0 ? new Date() : null,
                        u_IDUser: details.updateStatus > 0 ? this.state.idUser : 0,
                        isDeleted: false,
                        deletedDate: null,
                        salesReturnInwardList: salesReturnInwardList,
                        d_IDUser: 0,
                    }
                    this.isSubmitting = true;
                    this.setState({ isSaving: true });
                    this.transactionStockServices.submitSalesReturnInwardInsertUpdate(requestData)
                        .then((response) => {
                            if (response.statusCode == 200 && response.responseItem !== null) {
                                let dynamicData = response.responseItem.responseContent;
                                if (dynamicData !== null) {
                                    if (this.state.registerObject.updateStatus === 1) {
                                        this.SwalServices.Success("Updated successfully.");
                                    } else {
                                        this.SwalServices.Success("Saved successfully.");
                                    }
                                    if (this.state.urlId) {
                                        this.setState({ route: '/ledger-report' });
                                    } else {
                                        this.resetDetailsFields();
                                        this.setState(
                                            { isModalOpen: false },
                                            () => {
                                                this.procSelectAllRecordsSP();
                                            }
                                        );
                                    }
                                } else {
                                    this.procSelectAllRecordsSP();
                                }
                            } else {
                                this.setState(
                                    { isModalOpen: false },
                                    () => {
                                        this.SwalServices.Error(response.message);
                                        this.procSelectAllRecordsSP();
                                    }
                                );
                            }
                        }).finally(() => {
                            this.isSubmitting = false;
                            this.setState({ isSaving: false });
                        });
                }
            } else {
                this.SwalServices.Alert('Please add items')
            }
        }
    }


    getTransactionSalesReturnInwardSelectbyId = (idSalesReturnInward) => {
        if (idSalesReturnInward > 0) {
            this.transactionStockServices.getTransactionSalesReturnInwardSelectbyId(idSalesReturnInward).then((response) => {
                if (response.statusCode == 200 && response.responseItem !== null) {
                    let res = response.responseItem.responseContent[0][0];
                    let itemListRecords = response.responseItem.responseContent[1];
                    let itemList = [];
                    let registerObject = this.state.registerObject;
                    registerObject.idSalesReturnInward = res.idSalesReturnInward;
                    registerObject.salesReturnInNo = res.salesReturnInNo;
                    registerObject.updateStatus = 1;
                    registerObject.salesInDate = moment(res.date).format('YYYY-MM-DD');
                    registerObject.idVendor = res.idVendor;
                    registerObject.address = registerObject.vendorList.find(x => x.label === res.idVendor)?.address;

                    itemListRecords.map((details, keyId) => {
                        let obj = {
                            idSalesReturnInwardItems: details.idSalesReturnInwardItems,
                            idSalesReturnInward: details.idSalesReturnInward,
                            idSalesReturn: details.idSalesReturn,
                            idSalesReturnItems: details.idSalesReturnItems,
                            itemDrawingNo: details.itemDrawingNo,
                            itemItemType: details.itemItemType,
                            idItem: details.idItem,
                            itemName: details.itemName,
                            quantity: details.quantity,
                            pendingQty: details.pendingQty,
                            remarks: details.itemRemarks,
                            keyId: keyId + 1,
                            originalPendingQty: details.pendingQty + details.quantity,
                            salesReturnNo: details.salesReturnNo
                        }
                        itemList.push(obj);
                    })

                    this.setState({ registerObject: registerObject, itemRowData: itemList, isModalOpen: true, globalUserID: res.modifiedBy }, () => {
                        this.usp_Master_PartyAccountSelect()

                    });
                }
            });
        }
    }

    handleCellClick = (event) => {
        this.procSelectAllRecord2GridviewSP(event.data.idSalesReturnInward, "Sales Return Inward");
    };

    render() {
        return (
            <div className='calculate-planing'>
                <div className='data-display'>
                    <div className='data-display-inner relative'>
                        <ButtonGrp buttons={['add', 'print']}
                            onClickHandlers={{
                                add: () => this.openPopUpForAddingItem(),
                                // update: () => this.openPopUpForUpdateItem(),
                                print: this.handlePrint,
                            }}
                        />
                        <MrsRegisterPopup
                            isModalOpen={this.state.isModalOpen}
                            setOpenModel={this.setOpenModel.bind(this)}
                            registerObject={this.state.registerObject}
                            itemObject={this.state.itemObject}
                            handleChangeForRegister={this.handleChangeForRegister.bind(this)}
                            handleChangeForItem={this.handleChangeForItem.bind(this)}
                            handleChangeForDropdown={this.handleChangeForDropdown.bind(this)}
                            onGridReady={this.onGridReady.bind(this)}
                            close={this.closePopup.bind(this)}
                            submit={this.submit.bind(this)}
                            isSaving={this.state.isSaving}
                            validState={this.state.validState}
                            itemRowData={this.state.itemRowData}
                            itemColDefs={this.state.itemColDefs}
                            open={this.state.open}
                            openPopup={() => this.setState({ open: true })}
                            back={this.back.bind(this)}
                            partyAccountList={this.state.partyAccountList}
                            addSalesReturn={this.addSalesReturn.bind(this)}
                            firstSalesReturnList={this.state.firstSalesReturnList}
                            secondSalesReturnList={this.state.secondSalesReturnList}
                            onSelectionChanged={this.onSelectionChanged.bind(this)}
                            addProduct={this.addProduct.bind(this)}
                            onSelectionItemsChanged={this.onSelectionItemsChanged.bind(this)}
                            onItemRowDataClicked={this.onItemRowDataClicked.bind(this)}
                            insertItem={this.insertItem.bind(this)}
                            clear={this.clear.bind(this)}
                            delete={this.delete.bind(this)}
                            usp_Users={this.state.usp_Users}
                            globalUserID={this.state.globalUserID}
                        />
                        <div className="table cursor-default w-full bg-white shadow-normalShadow rounded-[10px] pb-[44px] pt-[10px] px-[10px]">
                            <div className="table-1 w-full px-[1px] rounded-[5px]" style={{ height: "calc(100vh - 300px)" }}>
                                <div className="table-inner">
                                    <h1 className="text-blue text-[16px] font-semibold py-[5px] px-[9px] pt-[0]">Sales return inward</h1>
                                </div>
                                <AgGridReact
                                    rowData={this.state.rowData}
                                    rowHeight={this.state.rowHeight}
                                    columnDefs={this.state.colDefs}
                                    pagination={true}
                                    paginationPageSize={this.state.paginationPageSize}
                                    onRowDoubleClicked={this.onRowDoubleClicked}
                                    // onGridReady={this.onGridReady}
                                    overlayLoadingTemplate={'<span class="ag-overlay-loading-center">Loading data...</span>'}
                                    overlayNoRowsTemplate="<span'>No Rows To Show</span>"
                                    onCellClicked={this.handleCellClick}
                                />
                            </div>
                        </div>

                        <div className="table w-full mt-[10px] bg-white shadow-normalShadow rounded-[10px] pb-[44px] pt-[10px] px-[10px]">
                            <div className={`table-2 w-full px-[1px] rounded-[5px] ${this.state.isTable2Expanded ? 'h-[448px]' : 'h-[0]'}`}>
                                <div className="table-inner" onClick={() => this.toggleExpandCollapseTable(2)}>
                                    <h1 className="text-blue text-[16px] font-semibold py-[5px] px-[9px] pt-[0]">Details</h1>
                                </div>
                                <AgGridReact
                                    rowData={this.state.table2Data}
                                    columnDefs={this.state.table2ColDefs}
                                    rowHeight={this.state.rowHeight}
                                    pagination={true}
                                    paginationPageSize={this.state.paginationPageSize}
                                    onGridReady={this.onGridReady}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
